import * as React from "react";
import { cn } from "../lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex w-full rounded-buttons border border-stone dark:border-dark-border bg-transparent px-4 py-2.5 text-sm text-near-black dark:text-dark-text transition-all duration-200 ease-out",
          "placeholder:text-graphite/60 dark:placeholder:text-dark-muted/60",
          "focus-visible:border-slate-border focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-slate-border dark:focus-visible:border-electric-lime dark:focus-visible:ring-electric-lime",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
